import { Component, ProgressBar, Slider, _decorator } from 'cc';

const { ccclass, requireComponent, executeInEditMode } = _decorator;

@ccclass('SliderProgressBar')
@executeInEditMode
@requireComponent([Slider, ProgressBar])
export default class SliderProgressBar extends Component {
    protected onLoad(): void {
        const slider = this.getComponent(Slider);
        const progressBar = this.getComponent(ProgressBar);
        // sync progress of slider to progress bar
        slider.node.on(Slider.EventType.PROGRESS_CHANGED, (progress: number) => {
            progressBar.progress = progress;
        });
        progressBar.progress = slider.progress;
    }
}
